import type { ComponentProps } from 'react';
import { MockBrandSelect } from 'wingman-fe';

import { ThemedExample } from '#src/components/ThemedExample/ThemedExample.tsx';

type Props = Pick<ComponentProps<typeof MockBrandSelect>, 'variant'>;

export const SeekBrandSelect = ({ variant }: Props) => (
  <ThemedExample>
    <MockBrandSelect
      hirerId="seekAnzPublicTest:organization:seek:93WyyF1h"
      pageSize={2}
      showStorybookAction
      variant={variant}
    />
  </ThemedExample>
);
